module.exports = __webpack_public_path__ + "static/media/discord.5e2c1dd7.png";